import React, { useState } from 'react';
import Button from 'housecall-ui/dist/library/Buttons/Button';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';

const DEFAULT_IMAGE_SRC = '/assets/C2QB_green_btn_med_default.svg';
const HOVER_IMAGE_SRC = '/assets/C2QB_green_btn_med_hover.svg';

const useStyles = makeStyles({
  button: {
    margin: 0,
    border: 'none',
    background: 'none',
    '&:hover': {
      background: 'none',
    },
  },
});

type Props = {
  onClick: () => void,
};

const ConnectToQuickbooksButton = ({ onClick }: Props) => {
  /**
   * This component styling is *required* to comply with Intuit naming and logo guidelines
   * https://developer.intuit.com/app/developer/qbo/docs/go-live/list-on-the-app-store/naming-and-logo-guidelines
   */

  const [imageSrc, setImageSrc] = useState(DEFAULT_IMAGE_SRC);
  const { button } = useStyles();

  const showHoverImage = () => setImageSrc(HOVER_IMAGE_SRC);
  const showDefaultImage = () => setImageSrc(DEFAULT_IMAGE_SRC);

  return (
    <Button
      className={button}
      disableRipple
      onMouseEnter={showHoverImage}
      onMouseLeave={showDefaultImage}
      onClick={onClick}
      data-testid="connect"
    >
      <img src={imageSrc} alt="Connect to QuickBooks" />
    </Button>
  );
};

export default ConnectToQuickbooksButton;
